// Module
var code = `<template class="transaction-categories-lookup">
  <require from="./transaction-categories-lookup.scss"></require>
  <div mdc-menu-surface-anchor>
    <mdc-text-field ref="functionInput" label.bind="placeholder" readonly.bind="readonly" disabled.bind="disabled"></mdc-text-field>
    <mdc-lookup options.bind="getOptions" view-model.ref="lookup" display-field="name" value-field="id" debounce="0" value.bind="value" input.bind="functionInput" preload-options natural-width hoist-to-body two-line select-on-blur select-on-tab>
      <template replace-part="option">
        <mdc-list-item-primary-text>\${option.name}</mdc-list-item-primary-text>
        <mdc-list-item-secondary-text>\${option.externalId}</mdc-list-item-secondary-text>
      </template>
    </mdc-lookup>
  </div>
</template>
`;
// Exports
export default code;